import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import {
    RouteWithLayout,
    MainLayout,
} from './pages/common';

import {
    Main as MainPage,
    AboutIntroduction as AboutIntroductionPage,
    AboutProduction as AboutProductionPage,
    AboutSustainability as AboutSustainabilityPage,

    StyleFabricList as StyleFabricListPage,
    StyleFabricDetail as StyleFabricDetailPage,


    BbsList as BbsListPage,
    BbsView as BbsViewPage,

    StoryList as StoryListPage,
    StoryView as StoryViewPage,
    NewsList as NewsListPage,
    NewsView as NewsViewPage,

    NewMaterialList as NewMaterialListPage,
    NewMaterialView as NewMaterialViewPage,

    ProductionList as ProductionListPage,
    ProductionView as ProductionViewPage,
} from './pages';

const Routes = (props) => {
    console.log('props', props);
    return (
        <Switch>
            {/*  Main */}
            <RouteWithLayout
                component={MainPage}
                exact
                layout={MainLayout}
                path='/'
                containerClassName='main'
                {...props}
            />

            {/* Introduction */}
            <RouteWithLayout
                component={AboutIntroductionPage}
                exact
                layout={MainLayout}
                path='/about/introduction'
                containerClassName='about'
                {...props}
            />
            <RouteWithLayout
                component={AboutSustainabilityPage}
                exact
                layout={MainLayout}
                path='/about/sustainability'
                containerClassName='about'
                {...props}
            />
            <RouteWithLayout
                component={AboutProductionPage}
                exact
                layout={MainLayout}
                path='/about/production'
                containerClassName='about'
                {...props}
            />

            {/* Style & Fabric */}
            <RouteWithLayout
                component={StyleFabricListPage}
                exact
                layout={MainLayout}
                path='/style-fabric'
                containerClassName='style-fabric'
                {...props}
            />
            <RouteWithLayout
                component={StyleFabricDetailPage}
                exact
                layout={MainLayout}
                path='/style-fabric/:id'
                containerClassName='style-fabric-detail'
                {...props}
            />

            {/* 
                Stories & News
                : All
            */}
            <RouteWithLayout
                component={BbsListPage}
                exact
                layout={MainLayout}
                path='/stories-news'
                containerClassName='stories-news'
                {...props} />
            <RouteWithLayout
                component={BbsViewPage}
                exact
                layout={MainLayout}
                path='/stories-news/:id'
                containerClassName='stories-news'
                {...props} />
            {/* Story */}
            <RouteWithLayout
                component={BbsListPage}
                exact
                layout={MainLayout}
                path='/story'
                containerClassName='stories-news'
                {...props}
            />
            <RouteWithLayout
                component={BbsViewPage}
                exact
                layout={MainLayout}
                path='/story/:id'
                containerClassName='stories-news'
                {...props} />
            {/* News */}
            <RouteWithLayout
                component={BbsListPage}
                exact
                layout={MainLayout}
                path='/news'
                containerClassName='stories-news'
                {...props}
            />
            <RouteWithLayout
                component={BbsViewPage}
                exact
                layout={MainLayout}
                path='/news/:id'
                containerClassName='stories-news'
                {...props} />

            {/* New Material & Production 
                : All
            */}
            <RouteWithLayout
                component={BbsListPage}
                exact
                layout={MainLayout}
                path='/new-material-production'
                containerClassName='new-material-production'
                {...props} />
            <RouteWithLayout
                component={BbsViewPage}
                exact
                layout={MainLayout}
                path='/new-material-production/:id'
                containerClassName='new-material-production'
                {...props} />
            <RouteWithLayout
                component={BbsListPage}
                exact
                layout={MainLayout}
                path='/new-material'
                containerClassName='new-material-production'
                {...props} />
            <RouteWithLayout
                component={BbsViewPage}
                exact
                layout={MainLayout}
                path='/new-material/:id'
                containerClassName='new-material-production'
                {...props} />
            <RouteWithLayout
                component={BbsListPage}
                exact
                layout={MainLayout}
                path='/production'
                containerClassName='new-material-production'
                {...props} />
            <RouteWithLayout
                component={BbsViewPage}
                exact
                layout={MainLayout}
                path='/production/:id'
                containerClassName='new-material-production'
                {...props} />
        </Switch>
    )
}

export default Routes;